import React from "react"; // eslint-disable-line no-unused-vars
import { Grid2 as Grid, Typography, IconButton, Link } from "@mui/material";
import {
  Edit as EditIcon,
  DeleteForever as RemoveIcon,
} from "@mui/icons-material";
import { Donation, CodeDetails, Settings, Charity } from "../types";
import { convertToCurrency } from "../utilities/tools";

export interface DonationSummaryProps {
  busy: boolean;
  codeDetails: CodeDetails;
  settings: Settings;
  donation: Donation;
  charity: Charity;
  editMode: boolean;
  handleEditMode: () => void;
  handleRemove: () => void;
}

export const DonationSummary = ({
  busy,
  codeDetails,
  settings,
  donation,
  charity,
  editMode,
  handleEditMode,
  handleRemove,
}: DonationSummaryProps): React.JSX.Element | null => {
  return (
    <Grid size={{ xs: 12, sm: 8 }}>
      <Grid size={{ xs: 12 }} container>
        <Grid size={{ xs: 12 }} container>
          <Grid size={{ xs: 8 }}>
            <Typography
              variant="h5"
              style={{
                marginBottom: "8px",
              }}
            >
              {charity.managed.displayName}
            </Typography>
            <Typography variant="body1" component="div">
              <Link href={`/charity/?charityId=${charity.ein}`}>
                {`EIN: ${charity.ein.split("-")[0].slice(0, 2)}-${charity.ein
                  .split("-")[0]
                  .slice(2)} ${charity.chapter}`}
              </Link>
            </Typography>
            <Typography variant="body1" component="div">
              {`Donation: ${convertToCurrency(donation.amount)}`}
            </Typography>
          </Grid>
          <Grid size={{ xs: 4 }} style={{ textAlign: "right" }}>
            {!editMode && (
              <IconButton
                disabled={busy}
                onClick={() => {
                  handleEditMode();
                }}
              >
                <EditIcon />
              </IconButton>
            )}
            {!editMode && (
              <IconButton
                disabled={busy}
                onClick={() => {
                  handleRemove();
                }}
              >
                <RemoveIcon />
              </IconButton>
            )}
          </Grid>
        </Grid>
        <Grid size={{ xs: 12 }} container spacing={1}>
          {donation.message && (
            <Grid size={{ xs: 12 }}>
              <Typography
                variant="body1"
                component="div"
                style={{ textDecoration: "italics" }}
              >
                {donation.message}
              </Typography>
            </Grid>
          )}
          {settings.allowedInstructions.indexOf("OptIn") >= 0 &&
          donation.instructions.type.indexOf("OptIn") >= 0 ? (
            <Grid size={{ xs: 12 }}>
              <Typography variant="body1" component="div">
                {`Name and email shared with this charity:`}
                <br />
                {`${donation.instructions.optIn.name} - ${donation.instructions.optIn.email}`}
              </Typography>
            </Grid>
          ) : (
            <Grid size={{ xs: 12 }}>
              <Typography variant="body1" component="div">
                {`Anonymous donation, name and email not shared with this charity`}
              </Typography>
            </Grid>
          )}
          {settings.allowedInstructions.indexOf("Paper") >= 0 &&
            settings.cardValueMinimumPaper <= codeDetails.originalAmount && (
              <React.Fragment>
                {donation.instructions.type.indexOf("Paper") >= 0 ? (
                  <Grid size={{ xs: 12 }}>
                    <Typography variant="body1" component="div">
                      {`Mail check to address:`}
                    </Typography>
                    <Typography variant="body1" component="div">
                      <Typography variant="body1" component="div">
                        {`${donation.instructions.address.name}`}
                      </Typography>
                      <Typography variant="body1" component="div">
                        {`${donation.instructions.address.street}`}
                      </Typography>
                      <Typography variant="body1" component="div">
                        {`${donation.instructions.address.unit}`}
                      </Typography>
                      <Typography variant="body1" component="div">
                        {`${donation.instructions.address.city} ${donation.instructions.address.state}, ${donation.instructions.address.zip}`}
                      </Typography>
                    </Typography>
                  </Grid>
                ) : (
                  <Grid size={{ xs: 12 }}>
                    <Typography variant="body1" component="div">
                      {`Send funds directly to the charity`}
                    </Typography>
                  </Grid>
                )}
              </React.Fragment>
            )}
          {settings.allowedInstructions.indexOf("Attribution") >= 0 &&
            donation.instructions.type.indexOf("Attribution") >= 0 && (
              <Grid size={{ xs: 12 }}>
                <Typography variant="body1" component="div">
                  {`Donate in honor of: ${donation.instructions.attribution}`}
                </Typography>
              </Grid>
            )}
          {settings.allowedInstructions.indexOf("Designation") >= 0 &&
            donation.instructions.type.indexOf("Designation") >= 0 && (
              <Grid size={{ xs: 12 }}>
                <Typography
                  variant="body1"
                  component="div"
                >{`Program request: ${donation.instructions.designation}`}</Typography>
              </Grid>
            )}
          {settings.allowedInstructions.indexOf("Note") >= 0 &&
            donation.instructions.type.indexOf("Note") >= 0 && (
              <Grid size={{ xs: 12 }}>
                <Typography
                  variant="body1"
                  component="div"
                >{`TisBest staff: ${donation.instructions.notes}`}</Typography>
              </Grid>
            )}
        </Grid>
      </Grid>
    </Grid>
  );
};
